import { LogLevel } from '@/lib/logger';
import type { ColorScheme, PrimaryColor } from '@/styles/theme-v2/theme/types';

import { getSiteURL } from './lib/v2/get-site-url';

export interface Config {
  site: {
    name: string;
    description: string;
    colorScheme: ColorScheme;
    primaryColor: PrimaryColor;
    themeColor: string;
    url: string;
    api: string;
    version: string;
  };
  api: {
    token: string;
    base: string;
  };
  logLevel: keyof typeof LogLevel;
  gtm?: { id?: string };
  url: {
    api: string;
  };
  reverb: {
    key: string;
    host: string;
    port: number;
    scheme: string;
  };
  features: {
    enableV2Requests: boolean;
  };
  stripe: {
    publishableKey: string;
  };
  sentry: {
    dsn: string;
  };
  newrelic: {
    accountId: string;
    applicationId: string;
    licenseKey: string;
    trustKey: string;
    agentId: string;
  };
}

export const config = {
  site: {
    name: 'HOAONE',
    description: 'HOAONE',
    colorScheme: 'light',
    themeColor: '#0066cc',
    primaryColor: 'professionalBlue',
    url: getSiteURL(),
    api: import.meta.env.VITE_APP_API_URL,
    version: import.meta.env.VITE_SITE_VERSION || '0.0.0',
  },
  api: {
    token: 'accessToken',
    base: import.meta.env.VITE_APP_API_URL,
  },
  url: {
    api: import.meta.env.VITE_APP_API_URL,
  },
  logLevel: (import.meta.env.VITE_LOG_LEVEL as keyof typeof LogLevel) || LogLevel.ALL,
  gtm: { id: import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID },
  reverb: {
    key: import.meta.env.VITE_REVERB_APP_KEY,
    host: import.meta.env.VITE_REVERB_HOST || 'localhost',
    port: parseInt(import.meta.env.VITE_REVERB_PORT || '8080', 10),
    scheme: import.meta.env.VITE_REVERB_SCHEME || 'http',
  },
  features: {
    enableV2Requests: import.meta.env.VITE_ENABLE_V2_REQUESTS === 'true',
  },
  stripe: {
    publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',
  },
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
  },
  newrelic: {
    accountId: import.meta.env.VITE_NEWRELIC_ACCOUNT_ID,
    applicationId: import.meta.env.VITE_NEWRELIC_APPLICATION_ID,
    licenseKey: import.meta.env.VITE_NEWRELIC_LICENSE_KEY,
    trustKey: import.meta.env.VITE_NEWRELIC_TRUST_KEY,
    agentId: import.meta.env.VITE_NEWRELIC_AGENT_ID,
  },
} satisfies Config;
